import { __extends } from "tslib";
var numbersRegex = /[0-9]+/gi;
// eslint-disable-next-line no-useless-escape
var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var phoneRegex = /^[0]\d{10}$/;
var BaseValidator = /** @class */ (function () {
    function BaseValidator(required, validate) {
        this.required = required;
        this.validate = validate;
    }
    return BaseValidator;
}());
export { BaseValidator };
var RequiredValidator = /** @class */ (function (_super) {
    __extends(RequiredValidator, _super);
    function RequiredValidator(required) {
        if (required === void 0) { required = 'Enter a value'; }
        return _super.call(this, required) || this;
    }
    return RequiredValidator;
}(BaseValidator));
export { RequiredValidator };
var LettersValidator = /** @class */ (function (_super) {
    __extends(LettersValidator, _super);
    function LettersValidator(required) {
        if (required === void 0) { required = 'Enter some letters'; }
        return _super.call(this, required, {
            lettersOnly: function (value) {
                return !numbersRegex.test(value) || "Only enter letters here.";
            },
        }) || this;
    }
    return LettersValidator;
}(BaseValidator));
export { LettersValidator };
var NumbersValidator = /** @class */ (function (_super) {
    __extends(NumbersValidator, _super);
    function NumbersValidator(required) {
        if (required === void 0) { required = 'Enter some numbers'; }
        return _super.call(this, required, {
            numbersOnly: function (value) {
                return numbersRegex.test(value) || "Only enter numbers here.";
            },
        }) || this;
    }
    return NumbersValidator;
}(BaseValidator));
export { NumbersValidator };
var EmailValidator = /** @class */ (function (_super) {
    __extends(EmailValidator, _super);
    function EmailValidator(required) {
        if (required === void 0) { required = 'Enter an email address'; }
        return _super.call(this, required, {
            emailValid: function (value) {
                return emailRegex.test(value) || "Looks like you might have made a typo here.";
            },
        }) || this;
    }
    return EmailValidator;
}(BaseValidator));
export { EmailValidator };
var PhoneValidator = /** @class */ (function (_super) {
    __extends(PhoneValidator, _super);
    function PhoneValidator(required) {
        if (required === void 0) { required = 'Enter a phone number'; }
        return _super.call(this, required, {
            phoneValid: function (value) {
                return phoneRegex.test(value) || "Enter a ten digit number without the country code.";
            },
        }) || this;
    }
    return PhoneValidator;
}(BaseValidator));
export { PhoneValidator };
var ConfirmationPasswordValidator = /** @class */ (function (_super) {
    __extends(ConfirmationPasswordValidator, _super);
    function ConfirmationPasswordValidator(required, password) {
        if (required === void 0) { required = 'Confirm your password'; }
        return _super.call(this, required, {
            passwordsMatch: function (confirmationPassword) {
                return confirmationPassword === password || "Your passwords don't match.";
            },
        }) || this;
    }
    return ConfirmationPasswordValidator;
}(BaseValidator));
export { ConfirmationPasswordValidator };
var WebAddressValidator = /** @class */ (function (_super) {
    __extends(WebAddressValidator, _super);
    function WebAddressValidator(required, badUrl) {
        if (required === void 0) { required = 'Enter a URL'; }
        if (badUrl === void 0) { badUrl = 'Bad URL'; }
        return _super.call(this, required, {
            isBadUrl: function (value) {
                if (!value && !required)
                    return true;
                try {
                    if (!value.startsWith('http')) {
                        value = "https://".concat(value);
                    }
                    new URL(value);
                    return true;
                }
                catch (error) {
                    return badUrl;
                }
            },
        }) || this;
    }
    return WebAddressValidator;
}(BaseValidator));
export { WebAddressValidator };
